
<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h1>Ingresar serie a correlacionar (año, valor)</h1>
              <button @click="$emit('close')">&#x2716;</button>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <p>
                Con esta opción es posible correlacionar los datos del Atlas a
                nivel de pixeles individuales, con una serie de tiempo ingresada
                por el usuario generando un mapa de correlación
              </p>
              <h3>Desde datos pre cargados</h3>
              <button
                class="btn btn-secondary"
                style="margin-left: 10px"
                @click="set_text_box(val)"
                v-bind:key="key"
                v-for="(val, key) in available_csvs_data"
              >
                {{ val }}
              </button>
              <hr />
              <h3>Desde datos ingresados</h3>
              <p>
Ingresar datos en dos columnas (año y valor) sin encabezados. Acepta comas o tabulación como separadores válidos. También se puede copiar- pegar desde un archivo excel de dos columnas. Introducir sólo números
              </p>
              <div class="container" style="display: flex; justify-content: space-around">
              <label for="nombre">Nombre para mapa (opcional) </label>
                            <input name="nombre"
                type="input"
                v-model="name_for_map"
              />


              </div>
              <div>
                            <p>
              {{txt_fuente}}
            </p>
              </div>

              <hr />
              <textarea v-model="time_series_input" cols="50" rows="6">
              </textarea>
              <hr />
              <input
                type="checkbox"
                v-model="filter_non_significative"
              />Mostrar solo correlaciones significativas (p &#60; 0.05)
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                type="button"
                class="btn btn-success"
                style="width: 100%"
                @click="sendMeanData"
              >
                Calcular mapa de correlación
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalCorrSADA",
  components: {},
  props: ["options", "waiting", "waiting_msg",'current_map_special_name'],
  data() {
    return {
      time_series_input: "",
      filter_non_significative: false,
      available_csvs_data: [],
      name_for_map: "",
      txt_fuente: "",
    };
  },
  mounted() {
    this.axios.get("./get_csv_names").then((response) => {
      this.available_csvs_data = response.data["disponibles"];
    });
  },
  methods: {
    set_text_box(key) {

      this.name_for_map = key;
      this.axios.get(`./get_correl_csv_content/${key}`).then((response) => {
        if (response.data["existe"] === 1) {
          this.time_series_input = response.data["contenido"];
          this.txt_fuente = response.data['fuente']
        }
      });
    },

    sendMeanData() {
      let filas = this.time_series_input.trim().split("\n");
      let sep = null;
      if (this.time_series_input.indexOf(",") > 0) {
        sep = ",";
      } else if (this.time_series_input.indexOf("\t")) {
        sep = "\t";
      } else {
        alert("Separador no identificado colocar tabs o comas.");
        return;
      }

      // formato de valores
      let x_values = [];
      let y_values = [];
      for (let f of filas) {
        let row = f.split(sep);
        let parsed_row = row.map(function (x) {
          return +x;
        });
        let x = parsed_row[0];
        let y = parsed_row[1];

        if (isNaN(x) || isNaN(y)) {
          let err_msg =
            "Valores no válidos en formulario. No pueden ser valores no numéricos";
          alert(err_msg);
          return;
        }

        x_values.push(x);
        y_values.push(y);
      }
      if (x_values.length != y_values.length) {
        let err_msg = `El largo de serie de años no calza con serie de valores. largos ${x_values.length} ${y_values.length}`;
        alert(err_msg);
        return;
      }

      let url = "./calc_corr_sada_raster";
      let filter_str = this.filter_non_significative ? "1" : "0";
      const dt = {
        years_to_query: x_values,
        time_series: y_values,
        filter_sig: filter_str,
      };

      this.$emit("update:waiting", true);
      this.$emit("update:waiting_msg", "Calculando raster correlacion");
      this.axios
        .post(url, dt, { withCredentials: true })
        .then(() => {
          this.$emit("update:current_map_special_name",this.name_for_map);
          this.$emit("post_calc")
        })
        .finally(() => {
          this.$emit("update:waiting", false);
          this.$emit("update:waiting_msg", "");
          this.$emit("close");
        });
    },
  },
};
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 800px;
overflow-y: auto;
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
